import { Box, Typography } from "@dealer-center/core-components";
import type { DetailComponentProps } from "../../MasterDetailLayout";

export const AppointmentItemDetail = ({ selectedId }: DetailComponentProps) => {
  if (!selectedId) {
    return (
      <Box sx={{ color: "text.secondary", p: 4, textAlign: "center" }}>
        <Typography variant="body-md">
          Select a Appointment to view details
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6">Appointment Detail — {selectedId}</Typography>
      <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
        TODO: render Appointment detail for {selectedId}
      </Typography>
    </Box>
  );
};
